import React from 'react';
import { Text, Card, Icon, Button } from '../../../common/components';
import { IconNames } from '../../../common/components/Icon/IconNames';
import { RegistryDataItem } from '../../config/registryData';

interface DashboardCardProps {
  registry: RegistryDataItem;
  onMoreInfo: () => void;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ registry, onMoreInfo }) => (
  <Card className="CardRegistryDash">
    <div className="CardRegistryDash__header mb-1">
      <Icon 
        name={registry.iconName as IconNames} 
        color="AccentOrange" 
        className="CardRegistryDash__icon" 
      />
      <div>
        <Text size="h3" color="Neutral800">
          {registry.title}
        </Text>
        <Button 
          title="Více informací" 
          variant="text" 
          onClick={onMoreInfo} 
        />
      </div>
    </div>
    <div className="CardRegistryDashDetails">
      <Text size="body-small" weight="500" color="Neutral600">
        {registry.checkFrequency}
      </Text>
      <Text size="body-medium" weight="600" color="Neutral800">
        {registry.monitoringDetails}
      </Text>
    </div>
  </Card>
);

export default DashboardCard;
